module.exports = __webpack_public_path__ + "static/packaging-webinars-hero-f8ac73a09408621aafd3399c2181e41a.jpg";